<mat-table *ngIf="(pack.archives ?? []).length > 0" [dataSource]="pack.archives" class="w-100-p">
  <ng-container matColumnDef="applianceGroup">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'APPLIANCE_GROUPS' | translate }}</th>
    <td mat-cell *matCellDef="let archive">
      {{ availableApplianceGroups[archive.applianceGroup.key] ? availableApplianceGroups[archive.applianceGroup.key].translatedName : '' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="creationDate">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATION_DATE' | translate }}</th>
    <td mat-cell *matCellDef="let archive">{{ archive.creationDate | date : 'dd/MM/yyyy HH:mm' }}</td>
  </ng-container>
  <ng-container matColumnDef="createdBy">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATED_BY' | translate }}</th>
    =
    <td mat-cell *matCellDef="let archive">
      {{
        archive.creator.firstName && archive.creator.lastName
          ? archive.creator.firstName + ' ' + archive.creator.lastName
          : archive.creator.nickname
      }}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'ARCHIVES.STATUS' | translate }}</th>
    <td mat-cell *matCellDef="let archive">{{ archive.status | translate }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col" class="column-buttons"></th>
    <td mat-cell *matCellDef="let archive" class="column-buttons">
      <div class="row">
        <div class="space-h-m">
          <a class="action" matTooltip="{{ 'DOWNLOAD' | translate }}" matTooltipClass="tooltip-main" [href]="archive.link">
            <i class="fas fa-download" aria-hidden="true"></i>
          </a>
        </div>
        <div class="space-h-m">
          <a
            class="action"
            *ngIf="archive.status !== 'PUBLISHED' && archive.applianceGroup"
            matTooltip="{{ 'PUBLISH' | translate }}"
            matTooltipClass="tooltip-main"
            (click)="publishArchive$.next(archive)"
          >
            <i class="fas fa-check" aria-hidden="true"></i>
          </a>
        </div>
        <a
          class="action"
          *ngIf="archive.status !== 'PUBLISHED'"
          matTooltip="{{ 'DELETE' | translate }}"
          matTooltipClass="tooltip-main"
          (click)="deleteArchive$.next(archive)"
        >
          <i class="fas fa-trash" aria-hidden="true"></i>
        </a>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="resolution">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'RESOLUTION' | translate }}</th>
    <td mat-cell *matCellDef="let archive">{{ archive.width + 'px x ' + archive.height }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</mat-table>
